'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { Networks } from 'AdsUI/lib/Constants';
import UILogo from 'UIComponents/image/UILogo';

const NetworkIcon = ({
  network,
  size = 28,
  className
}) => {
  switch (network) {
    case Networks.ADWORDS:
      return /*#__PURE__*/_jsx(UILogo, {
        name: "google-ads",
        height: size,
        className: className
      });

    case Networks.FACEBOOK:
      return /*#__PURE__*/_jsx(UILogo, {
        name: "facebook",
        height: size,
        className: className
      });

    case Networks.LINKEDIN:
      return /*#__PURE__*/_jsx(UILogo, {
        name: "linkedin",
        height: size,
        className: className
      });

    default:
      return null;
  }
};

NetworkIcon.propTypes = {
  network: PropTypes.oneOf(Object.keys(Networks)).isRequired,
  size: PropTypes.number,
  className: PropTypes.string
};
export default NetworkIcon;